import { render, staticRenderFns } from "./ChatsList.vue?vue&type=template&id=38768f4e&scoped=true"
import script from "./ChatsList.vue?vue&type=script&lang=js"
export * from "./ChatsList.vue?vue&type=script&lang=js"
import style0 from "./ChatsList.vue?vue&type=style&index=0&id=38768f4e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38768f4e",
  null
  
)

export default component.exports